export const destinations = {
    title: "Destinos",
    sortName: "Nombre",
    noResults: "Con resultados",
    tryDifferentSearch: "Intenta una búsqueda diferente"
};
